import { TabType } from "../components/CreateNoteModal/AITemplateModal/types";
import { Template } from "../service/templates.service";

export type TProceduralCode = {
  id: number;
  code: string;
  short_description: string;
  rationale: string;
  additional_fields?: Record<string, any> | null;
};

export type TDiagnosticCode = {
  id: number;
  code: string;
  short_description: string;
  rationale: string;
  additional_fields?: Record<string, any> | null;
};

export type TNotes = {
  client_id?: number;
  name?: string;
  summary?: string;
  audio_id?: number | string;
  id: number;
  title: string;
  note_type: number;
  note_type_info?: {
    pk: number;
    id: number;
    name: string;
    document: string;
    finished_generating: boolean;
    settings: { is_addon: boolean; is_cpt_codes: boolean };
  };
  uploaded_at: string;
  assessment: string;
  error_status: number;
  category_type: number;
  language_type: number;
  status: number;
  is_read: boolean;
  stats_transcribe_start_at: string;
  stats_generate_note_start_at: string;
  modality_type: number;
  duration_seconds: number;
  subject: string;
  intake_note: string;
  eap_intake_note: string;
  psych_intake_note: string;
  psych_followup_note?: string;
  data: string;
  document?: string;
  emdr_note: string;
  avs_email: string;
  objective: string;
  plan: string;
  gender_type: number;
  client?: number;
  location_type?: number;
  duration_type?: number | null;
  duration_addon_type?: number;
  client_name?: string;
  session_insights?: string;
  stats_generate_note_end_at: string;
  treatment_plan?: string;
  sol_psych_intake_note?: string;
  sol_psych_followup_note?: string;
  sol_therapy_intake_note?: string;
  sol_therapy_followup_note?: string;
  psychotherapy_minutes?: number;
  psychotherapy_minutes_explanation?: string;
  suggested_cpt_type?: number;
  suggested_cpt_code_explanation?: string;
  is_incapture?: boolean;
  system_metadata?: {
    [key: string]: any;
  };
  procedural_codes: TProceduralCode[] | null;
  procedural_code_status: ProceduralCodeStatus;
  diagnostic_codes: TDiagnosticCode[] | null;
  diagnostic_code_status: DiagnosticCodeStatus;
  has_transcript?: boolean;
};

export type Tdsm = {
  id: number;
  code: string;
  name: string;
};

export type TClient = {
  id: number;
  first_name: string;
  last_name: string;
};

export type TRecordingDetailsType = {
  title: string;
  note_type?: number;
  category_type: number;
  modality_type: string;
  gender_type: number;
  language_type: number;
  location_type?: number;
  duration_type?: number | null;
  duration_addon_type?: number;
  client_id?: number;
  description?: string;
  fileList?: any[];
  is_template?: boolean;
  template_id?: number;
  current_recording_id?: number;
};

export interface AppState {
  isCreateClientDrawerVisible: boolean;
  isCustomiseSectionVisible: boolean;
  selectedClient: any;
  uploadInProgress: boolean;
  isEditNote: boolean;
  isCreateModalVisible: boolean;
  isAITemplateModalVisible: boolean;
  isSubmissionInProgress: boolean;
  selectedNoteForEditing: any;
  isNotesViewVisible: boolean;
  uploadType: number;
  showRecordingView: boolean;
  loadingNotes: boolean;
  currentPage: number;
  isDemoPath: boolean;
  isMobilePath: boolean;
  openShare: boolean;
  showDemoSignupModal: boolean;
  addClientView: boolean;
  audioDevices: any[];
  customTemplateSelectedTab: TabType;
  demoState: {
    isClientModalOpen: boolean;
    isNoteModalOpen: boolean;
    clientForm: any;
    recordingDetails: any;
  };
  templateOpenedFromNoteModal: boolean;
  storedTemplateData: {
    id: number;
    name: string;
    document: string;
    isFromTemplate?: boolean;
  } | null;
  templates: Template[];
  selectedView: string;
  showRestrictionModal: boolean;
  showSettingsModal: boolean;
}

export type TClientForm = {
  id?: number;
  uuid?: string;
  name: string;
  category_type: number;
  gender_type: number;
  language_type: number;
  diagnosis_ids?: string[] | number[];
  refer_type?: number;
  age?: number | string;
  mrn?: string | null;
  date_of_birth?: string | null;
  context?: string;
  progress_summary?: TProgressSummary;
  progress_summary_last_updated_at?: string;
  diagnoses?: Tdsm[];
};

export type TProgressSummary = {
  next_steps: string;
  primary_concern: string;
  session_summary: string;
};

export enum ProceduralCodeStatus {
  PENDING = 0,
  COMPLETE = 1,
  NOT_PROCESSED = 2,
  FAILED = 3,
}

export enum DiagnosticCodeStatus {
  PENDING = 0,
  COMPLETE = 1,
  NOT_PROCESSED = 2,
  FAILED = 3,
}

export enum ModalityMode {
  audio = 0,
  dictate = 1,
  write = 2,
  upload = 3,
}

// TypeScript interfaces for onboarding form data
export interface OnboardingFormData {
  practice_area: string; // code
  specialty: string; // code
  referral_source: string;
  ehr: string;
  work_as: string;
}

export interface OnboardingData {
  specialty?: string; // for BE extraction compatibility
  referral_source?: string;
  ehr?: string;
  work_as?: string;
  completed?: boolean;
  start_time?: string;
  timezone?: string;
}
